import moment from 'moment/moment'
import React from 'react'
import Colors from 'utils/Colors'
import { formatInBrazilianDatetime, maskString } from 'utils/functions'
import { FindInPage, Remove } from '@mui/icons-material'
import { REVIEW_STATUS_MESSAGES, REVIEW_RESULT_MESSAGES } from 'utils/constants/types'
import { last } from 'lodash'
import StatusText from 'components/StatusText'
import ReviewButton from '../ReviewButton'
import { TableColumn } from './styles'

const ReviewRow = (props) => {
  const { review, onClick } = props

  const getResultColor = (decision) => {
    const colors = {
      APPROVED: Colors.green,
      REPROVED: Colors.red,
      null: Colors.gray,
    }
    return colors[decision]
  }

  const getReviewResult = (decision) => {
    if (decision) {
      return (
        <StatusText color={getResultColor(decision)}>
          {REVIEW_RESULT_MESSAGES[decision]}
        </StatusText>
      )
    }
  
    return (<Remove style={{ color: '#AAA' }} />)
  }


  const getReviewerName = (decisions) => {
    const reviewer = last(decisions)?.reviewer
    return reviewer ? reviewer.display_name : <Remove style={{ color: '#AAA' }} />
  }

  return (
    <tr id={review?.background_check?.person?.uuid}>
      <td>
        {formatInBrazilianDatetime(review?.created)}
      </td>
      <TableColumn>
        {review?.background_check?.person?.name?.toLowerCase()}
      </TableColumn>
      <td>{maskString(review?.background_check?.person?.cpf, 'cpf')}</td>
      <td>
        {moment(review?.background_check?.person?.birth_date).format(
          'DD/MM/yyyy',
        )}
      </td>
      <td>{review?.reason}</td>
      <td>{getReviewerName(review.decisions)}</td>
      <td>{REVIEW_STATUS_MESSAGES[review?.status]}</td>
      <td>{getReviewResult(review?.result)}</td>
      <td>
        <ReviewButton
          id={review.uuid}
          color={Colors.white}
          backgroundColor={Colors.blue}
          borderColor={Colors.darkBlue}
          icon={<FindInPage fontSize="small" />}
          onClick={onClick}
          text="Análise"
        />
      </td>
    </tr>
  )
}

export default ReviewRow
